<template>
  <div class="container">
    <div class="content">
        <h3>Forgot Password??</h3>
        <p>There's no such thing as forgot password, cuz why would you forget your password?</p>

        <h1>{{ formattedTime }}</h1>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
        time: 30, // 30 seconds in seconds
        };
    },
    computed: {
        formattedTime() {
        const hours = Math.floor(this.time / 3600);
        const minutes = Math.floor((this.time % 3600) / 60);
        const seconds = this.time % 60;
        return `${this.formatDigit(hours)}:${this.formatDigit(minutes)}:${this.formatDigit(seconds)}`;
        },
    },
    methods: {
        formatDigit(value) {
        return value < 10 ? `0${value}` : value;
        },
        startCountdown() {
        setInterval(() => {
            if (this.time > 0) {
            this.time--;
            } else {
                window.location.href = '/';
            }
        }, 1000);
        },
    },
    created() {
        this.startCountdown();
    },
}
</script>

<style lang="scss" scoped>
.container{
    width: 100%;
    min-height: 100vh;
    display: flex;
    // justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 5% 20px;
    // border: 1px solid red;

    .content {
        text-align: center;

        h3 {
            font-size: 2.5rem;
            color:#6c7a89;
        }

        p {
            font-size: 1rem;
        }

        h1 {
            margin: 3rem 0;
            color: rgba(255, 255, 255, 0.377);
            // border: 1px solid red;
        }
    }

}
</style>